import { EmptyState } from "../../../emptyState/EmptyState.js";
import { InfoTag } from "../../../infoTag/InfoTag.js";
import { Typography } from "../../../typography/Typography.js";
import { MultiSelectResultItem } from "../MultiSelectResultItem/MultiSelectResultItem.js";
import styles from "./MultiSelectResultList.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function MultiSelectResultList({
  title,
  items,
  emptyStateTitle,
  emptyStateDescription,
  onRemove,
  resultItemDynamicLabel,
  resultItemActions
}) {
  return /*#__PURE__*/_jsxs("div", {
    className: styles.container,
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.header,
      children: [/*#__PURE__*/_jsx(Typography, {
        margin: false,
        variant: "h4",
        children: title
      }), /*#__PURE__*/_jsx(InfoTag, {
        label: items.length.toString()
      })]
    }), items.length === 0 && /*#__PURE__*/_jsx("div", {
      className: styles.emptyState,
      children: /*#__PURE__*/_jsx(EmptyState, {
        title: emptyStateTitle ?? 'Keine Ergebnisse',
        description: emptyStateDescription ?? '',
        variant: "NO_CONTENT",
        size: "SMALL"
      })
    }), items.length > 0 && /*#__PURE__*/_jsx("div", {
      className: styles.list,
      children: items.map(item => /*#__PURE__*/_jsx(MultiSelectResultItem, {
        item: item,
        onRemove: onRemove,
        dynamicLabel: resultItemDynamicLabel,
        actions: resultItemActions
      }, item.id))
    })]
  });
}